import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
// import { Circles } from 'react-loader-spinner'; // Importing the loader component
import ResumeSkeleton from '../components/Loading/ResumeSkeleton';

const AdminRoute = ({ element }) => {
    const { auth, loading } = useContext(AuthContext);

    if (loading) {
        return (
            <div className="loader-container" style={{ marginTop: '70vh' }}>
                {/* <ResumeSkeleton/> */}
            </div>
        )
    }

    return auth && auth.isAdmin ? element : <Navigate to="/" />;
};

export default AdminRoute;
